import { render, staticRenderFns } from "./BaseRadioGroup.vue?vue&type=template&id=481e253c&"
import script from "./BaseRadioGroup.vue?vue&type=script&lang=js&"
export * from "./BaseRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports